'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.Resizable', []).factory('ResizableFactory', require('./factories/Resizable')).directive('rmResizable', require('./directives/ResizableDirective'));